import { render, staticRenderFns } from "./header.vue?vue&type=template&id=e44c41aa&scoped=true&"
var script = {}
import style0 from "./header.vue?vue&type=style&index=0&id=e44c41aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e44c41aa",
  null
  
)

export default component.exports